var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 104,
    viewBox: "0 0 56 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1695)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.701 4.36h42.6v13.08c-.6 2.76-2.16 8.52-6.72 28.44-3.96 17.28-6.48 30.12-6.48 40.8v6.96h-17.52v-5.4c0-9.84 2.28-19.56 8.04-37.56 7.68-23.88 9.36-30.24 9.36-33.72h-14.76V30.4H3.701V4.36z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.701 4.36h42.6v13.08c-.6 2.76-2.16 8.52-6.72 28.44-3.96 17.28-6.48 30.12-6.48 40.8v6.96h-17.52v-5.4c0-9.84 2.28-19.56 8.04-37.56 7.68-23.88 9.36-30.24 9.36-33.72h-14.76V30.4H3.701V4.36z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1695",
    x: -4.799,
    y: -4.14,
    width: 60.6,
    height: 107.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1695"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1695",
    result: "effect2_dropShadow_2805_1695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1695",
    result: "shape"
  })))));
}
Svg7.displayName = '7';
export default Svg7;